import { BreakPoint } from "./breakPoint";
import { ContractDetails } from "./contractDetails";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { IContractDetailsResponseData } from "../../../setup/api/services/contract/models";
import { getContractDetails } from "../../../setup/api/services/contract";
import { ROUTES } from "../../../setup/constants";
import { setAppToken } from "../../../setup/context/api";
import { AuthConfig } from "../../../setup/context/config/authConfig";
import LoginForm from "../../authentication/login/loginForm";
import { Footer } from "../../../components/common/footer";

export const PublicContractDetails = () => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const { id } = useParams();
  const [contract, setContract] = useState<IContractDetailsResponseData>();
  useEffect(() => {
    if (!AuthConfig.getAppToken())
      setAppToken()
        .then(() => {
          setIsAuthenticated(true);
        })
        .catch(() => {
          setIsAuthenticated(false);
        });
    else setIsAuthenticated(true);
  }, []);
  useEffect(() => {
    if (id && isAuthenticated)
      getContractDetails(id)
        .then((res) => {
          setContract(res.data);
        })
        .catch((error) => {
          console.error(error);
          navigate(ROUTES.CONTRACT_NOT_FOUND);
        });
  }, [id, isAuthenticated]);
  return contract ? (
    <BreakPoint
      leftElement={<LoginForm />}
      rightElement={
        <>
          <ContractDetails contract={contract} />
          <Footer />
        </>
      }
    />
  ) : null;
};
